
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cloud/[...folders]",
      function () {
        return require("private-next-pages/cloud/[...folders].tsx");
      }
    ]);
  